<div class="block-page-title" *ngIf="course">
    <h2 class="page-title">
        {{course.name ? course.name : 'Название курса'}}
    </h2>

    <div class="course-progress">
        <div class="progress-text-block">
            <div class="progress-text">Выполнено</div>
            <div class="progress-divide">{{course.started? course.started: '0'}}/{{course.totalcount}}</div>        
        </div>
        <div class="progress-line">
            <div class="progress-line-fill" [style.width]="((course.started/course.totalcount)*100)+'%'"></div>
        </div>
    </div>
</div>
<ng-container *ngIf="course && course.lessons">
    <app-lesson-list [lessons]="course.lessons"></app-lesson-list>
</ng-container>